<template>
	<div>
		<GlobalHeader />
		<LoyaltyProgramHero />
		<LoyaltyProgramPromoBanners />
		<LoyaltyProgramHowItWorks />
		<LoyaltyProgramPoints />
		<LoyaltyProgramPointsActivities />
		<LoyaltyProgramRewards />
		<LoyaltyProgramBanner />
		<GlobalFooter />
	</div>
</template>
<script lang="ts" setup>
const $t = useI18n().t
const route = useRoute()
const config = useNuxtApp().$config

useHead({
	title: $t('pages.loyalty_program.meta_title'),
	link: [
		{
			rel: 'canonical',
			href: config.public.baseUrl + route.fullPath,
		},
	],
	meta: [
		config.public.environment === 'production-to-change'
			? { name: 'robots', content: 'index, follow' }
			: { name: 'robots', content: 'noindex, nofollow' },
		{ name: 'description', content: $t('pages.loyalty_program.meta_description') },
		{ property: 'og:title', content: $t('pages.loyalty_program.meta_title') },
		{ property: 'og:description', content: $t('pages.loyalty_program.meta_description') },
	],
})
</script>
